export class HerxCapabilityDeniedError extends Error {
  public readonly code = 'HERX_CAPABILITY_DENIED';
  
  constructor(
    public readonly permission: string,
    public readonly capability: string,
    public readonly moduleId: string
  ) {
    super(`Capability Denied: Module '${moduleId}' attempted to access capability '${capability}' which requires permission '${permission}'.`);
    this.name = 'HerxCapabilityDeniedError';
  }

  public toJSON() {
    return {
      name: this.name,
      code: this.code,
      message: this.message,
      permission: this.permission,
      capability: this.capability,
      moduleId: this.moduleId
    };
  }
}
